import { useState, useEffect } from "react";
import { useCandidateData } from "./hooks/useCandidateData";
import { useSearchParams } from "./hooks/useSearchParams";
import Error from "./components/Error/Error";
import Loader from "./components/Loader/Loader";
import { Logo } from "./assets";
import Mainview from "./components/Mainview/Mainview";
import PartySelect from "./components/Header/PartySelect";
import Footer from "./components/Footer/Footer";
import { locales } from "./locales";
import CommuneAutocomplete from "./components/Header/CommuneAutocomplete";

function App() {
  const [filteredList, setFilteredList] = useState([]);
  const langId = useSearchParams("lang");
  const { data, loading, error } = useCandidateData(langId);
  const [isCommuneSearchActive, setIsCommuneSearchActive] = useState(false);

  const [width, setWindowWidth] = useState(0);
  const isDesktop = width > 750;
  // const buildNumber = process.env.BUILD_NUMBER;

  useEffect(() => {
    setTimeout(() => {
      window.wort.frameResize();
    }, 100);
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const updateDimensions = () => {
    const width = window.innerWidth;
    setWindowWidth(width);
  };

  useEffect(() => {
    if (data && data.data) {
      setFilteredList(data.data);
    }
  }, [data]);

  if (loading || loading) return <Loader />;

  if (!data || error) return <Error error={error} />;

  const rawDataSort = (a, b) => {
    if (
      a.type === locales[langId].communeTypeList &&
      b.type === locales[langId].communeTypeSmall
    ) {
      return -1;
    } else if (
      a.type === locales[langId].communeTypeSmall &&
      b.type === locales[langId].communeTypeList
    ) {
      return 1;
    } else {
      return a.commune.localeCompare(b.commune);
    }
  };

  const onCommuneSearch = (query) => {
    if (query && query !== "reset") {
      const filteredData = data.data.filter((item) => {
        return item.commune === query;
      });
      setFilteredList(filteredData);
      setIsCommuneSearchActive(true);
    } else if (query && query === "reset") {
      setFilteredList(data.data.sort(rawDataSort));
      setIsCommuneSearchActive(false);
    }
    window.wort.frameResize();
  };

  const onPartySearch = (query) => {
    if (query !== locales[langId].all) {
      const filteredData = data.data.map((element) => {
        return {
          ...element,
          parties: element.parties.filter(
            (subElement) => subElement.party === query
          ),
        };
      });
      // remove all communes without candidates
      const filteredCommunes = filteredData.filter((commune) =>
        commune.parties.some((party) => party.candidates.length > 0)
      );

      setFilteredList(filteredCommunes);
    } else {
      setFilteredList(data.data.sort(rawDataSort));
    }
    window.wort.frameResize();
  };

  const handleCommuneSearchFocus = () => {
    setIsCommuneSearchActive(true);
  };

  const handleCommuneSearchBlur = () => {
    setIsCommuneSearchActive(false);
  };

  console.log("=================data================");
  console.log(data);
  console.log("====================================");
  return (
    <>
      <div className="px-4">
        {isDesktop && (
          <>
            <div className="flex flex-row mt-12" style={{ marginBottom: 58 }}>
              <Logo style={{ width: "63.04px", height: "53px" }} />
              <div className="flex flex-col ml-4">
                <span className="font-medium text-5xl leading-10 mt-1.5 md:font-bold md:text-5xl md:leading-10 ">
                  {locales[langId].title}
                </span>
              </div>
            </div>
            <div className="flex flex-row justify-start items-center">
              <CommuneAutocomplete
                isDesktop={isDesktop}
                items={data.lookup.communes}
                communeQueryHandler={onCommuneSearch}
                communePlaceholder={locales[langId].communePlaceholder}
                noResultsText={locales[langId].noCommune}
                handleFocus={handleCommuneSearchFocus}
                handleBlur={handleCommuneSearchBlur}
              />
              <span className="text-lg font-medium leading-6">
                {" "}
                {locales[langId].or}
              </span>
              <PartySelect
                data={data.lookup.parties}
                partyQueryHandler={onPartySearch}
                isDesktop={isDesktop}
                isCommuneSearchActive={isCommuneSearchActive}
                langId={langId}
              />
            </div>
          </>
        )}
        {!isDesktop && (
          <div className="flex flex-col mt-24 ">
            <Logo style={{ width: "46px", height: "38px" }} />
            <span className="font-medium text-3xl leading-9 mt-1.5 lg:font-bold lg:text-5xl lg:leading-10 mb-10">
              {locales[langId].title}
            </span>
            <CommuneAutocomplete
              isDesktop={isDesktop}
              items={data.lookup.communes}
              communeQueryHandler={onCommuneSearch}
              communePlaceholder={locales[langId].communePlaceholder}
              noResultsText={locales[langId].noCommune}
              handleFocus={handleCommuneSearchFocus}
              handleBlur={handleCommuneSearchBlur}
            />
            <div className="inline-flex justify-center items-center w-full">
              <hr className="my-6 w-full h-0.5 bg-gray-200 rounded border-0" />
              <div className="absolute left-1/2 px-4 bg-white -translate-x-1/2">
                <span className="text-lg font-medium">
                  {locales[langId].or}
                </span>
              </div>
            </div>
            <PartySelect
              data={data.lookup.parties}
              partyQueryHandler={onPartySearch}
              isDesktop={isDesktop}
              isCommuneSearchActive={isCommuneSearchActive}
              langId={langId}
            />
          </div>
        )}

        <Mainview data={filteredList} langId={langId} isDesktop={isDesktop} />
      </div>
      <Footer
        data={data.lookup.communes}
        communeQueryHandler={onCommuneSearch}
        isDesktop={isDesktop}
        langId={langId}
      />
    </>
  );
}

export default App;
